import { render, staticRenderFns } from "./Metabase.vue?vue&type=template&id=a4524eb8"
import script from "./Metabase.vue?vue&type=script&lang=js"
export * from "./Metabase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports